// Module
var code = `<template> <div class="partial-activity-assignment"> </div> </template>`;
// Exports
module.exports = code;